/* bysundays — global behaviour.
   Everything here degrades gracefully: with JS off the header nav is a plain
   list, the currency picker is a real form, and the cart quantity controls are
   native number inputs inside a submitting form. */

(function () {
  'use strict';

  /* ---------- mobile navigation ---------- */
  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-nav-toggle]');
    if (!toggle) return;
    var header = toggle.closest('[data-header]');
    if (!header) return;
    var open = header.getAttribute('data-open') === 'true';
    header.setAttribute('data-open', open ? 'false' : 'true');
    toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-header][data-open="true"]').forEach(function (header) {
      header.setAttribute('data-open', 'false');
      var toggle = header.querySelector('[data-nav-toggle]');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    });
  });

  /* ---------- currency / country picker ----------
     Posts Shopify's own /localization form. No JS required — the buttons are
     submit buttons — this only saves a full page paint where possible. */
  document.querySelectorAll('[data-localization-form]').forEach(function (form) {
    form.addEventListener('submit', function () {
      form.setAttribute('aria-busy', 'true');
    });
  });

  /* ---------- cart quantity steppers ---------- */
  document.addEventListener('click', function (event) {
    var step = event.target.closest('[data-qty-step]');
    if (!step) return;
    var wrap = step.closest('[data-qty]');
    if (!wrap) return;
    var input = wrap.querySelector('input[name="quantity"], input[data-qty-input]');
    if (!input) return;

    var delta = step.getAttribute('data-qty-step') === 'up' ? 1 : -1;
    var next = Math.max(0, (parseInt(input.value, 10) || 0) + delta);
    if (String(next) === String(input.value)) return;
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Debounced auto-submit so a stepper click actually updates the cart. */
  var timers = new WeakMap();
  document.addEventListener('change', function (event) {
    var input = event.target.closest('[data-qty-input]');
    if (!input) return;
    var form = input.closest('form');
    if (!form) return;
    clearTimeout(timers.get(input));
    timers.set(
      input,
      setTimeout(function () {
        if (form.requestSubmit) form.requestSubmit();
        else form.submit();
      }, 350)
    );
  });

  /* ---------- gift note reveal ---------- */
  document.querySelectorAll('[data-gift-toggle]').forEach(function (box) {
    var panel = document.getElementById(box.getAttribute('aria-controls'));
    if (!panel) return;
    var sync = function () {
      panel.hidden = !box.checked;
    };
    box.addEventListener('change', sync);
    sync();
  });
})();
